<template>
  <div
    class="list-group-item my-2"
    draggable="true"
    @dragstart="handleDragStart"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "DraggableItem",
  props: {
    transferData: {
      type: Object,
    },
  },
  methods: {
    handleDragStart(event) {
      event.dataTransfer.setData("value", JSON.stringify(this.transferData));
    },
  },
};
</script>

<style scoped>
.list-group-item {
  width: 100%;
  text-align: center;
  cursor: move;
  flex-basis: 100%;
  height: fit-content;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
  background-color: white;
  border-radius: 4px;
  font-weight: 500;
  justify-content: center;
  outline: 0;
  position: relative;
  text-indent: 0.0892857143em;
  transition-duration: 0.28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  border: thin solid currentColor;
}
</style>
